import { render, staticRenderFns } from "./ClaimsDashboardView.vue?vue&type=template&id=e5c2e1c0&scoped=true"
import script from "./ClaimsDashboardView.vue?vue&type=script&lang=js"
export * from "./ClaimsDashboardView.vue?vue&type=script&lang=js"
import style0 from "./ClaimsDashboardView.vue?vue&type=style&index=0&id=e5c2e1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c2e1c0",
  null
  
)

export default component.exports